import React, { useState } from "react";
import { Checkbox, FormControlLabel, withStyles} from "@material-ui/core"
import "../../theme/news.scss"

const ModalSuscribe = (props:any): JSX.Element=>{

    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [correo, setCorreo] = useState("");
    const [comentario, setComentario] = useState(false);
    const [mercado, setMercado] = useState(false);
    const [economico, setEconomico] = useState(false);
    const [success, setSuccess] = useState(false);

    const validate = (email:any) => {
        if (!email) {
        //   errors.email = 'Required'
            setErrorText("Correo requerido.");
            setError(true);
            return false;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        //   errors.email = 'Invalid email address'
            setErrorText("Por favor, escribe una dirección de correo válida.");
            setError(true);
            return false;
        }
        setErrorText("");
        setError(false);
        return true;
    }

    const suscribe = (email:any) => {
        if(validate(email)){
            setSuccess(true);
            onSubmit(email);
        }

    }

    async function onSubmit(correo:any) {
        if (correo != null) {
            const _line = (economico ? "Económico,":"") + (comentario ? "Comentario Diario,":"") + (mercado ? "Mercados a la Apertura,":"");
            
          //lo guardamos en sendgrid
          const body = {
            list_ids: ["b46e2b23-4251-48f0-9c24-1aaf06e6619e"],
            contacts: [
              {
                email: correo,
                line: _line,
              },
            ],
          };
    
          await fetch('https://api.sendgrid.com/v3/marketing/contacts', {
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              authorization: 'Bearer ' + process.env.GATSBY_SENDGRID_API_KEY,
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            // redirect: 'follow', // manual, *follow, error
            // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body), // body data type must match "Content-Type" header
          });
          
    
        //   setMensajeCorrecto(true);
        }
      } // on submit
    const GreenCheckbox = withStyles({
        root: {
          color: "#FF5000",
          '&$checked': {
            color: "#FF5000",
          },
        },
        checked: {},
    })((props) => <Checkbox color="default" {...props} />);
    return(
        
                <div className='modal-news'>
                    <div className='wrap-modal-news'>
                        
                        {   !success &&
                            <div className="form-news">
                                <div className='header-modal-news'>
                                    <div className='close-modal-news'onClick={()=>props.closeModal()}>x</div>
                                    <div className='title-modal-news'>Subscríbete a nuestro Análisis</div>
                                </div>
                                <div className='content-news'>
                                    <p className="subtitle">Selecciona la información que quieras recibir a tu correo</p>
                                    <div className="selects">
                                        <div className="check">
                                            <FormControlLabel
                                                control={
                                                    <GreenCheckbox {...props}
                                                    defaultChecked={comentario} 
                                                    onChange={()=>setComentario(!comentario)}/>
                                                }
                                                label="Comentario Diario"
                                            />
                                        </div>
                                        <div className="check">
                                            <FormControlLabel
                                                control={
                                                    <GreenCheckbox {...props}
                                                    defaultChecked={mercado} 
                                                    onChange={()=>setMercado(!mercado)}/>
                                                }
                                                label="Mercados a la Apertura"
                                            />
                                        </div>
                                        <div className="check">
                                            <FormControlLabel
                                                control={
                                                    <GreenCheckbox {...props}
                                                    defaultChecked={economico} 
                                                    onChange={()=>setEconomico(!economico)}/>
                                                }
                                                label="Económico"
                                            />
                                        </div>
                                    </div>
                                    <div className="form">
                                        <p>Correo Electrónico</p>
                                        { error && <p className="error-mail">{errorText}</p> }
                                        <div className="inputs">
                                            <input type="text" value={correo} onChange={(e)=>setCorreo(e.target.value)}/>
                                            <div className="wrap-control">
                                                <button onClick={()=>suscribe(correo)}>Suscríbete</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            success && 
                            <div className="form-news">
                                <div className='header-modal-news'>
                                    <div className='close-modal-news' onClick={()=>props.closeModal()}>x</div>
                                    <div className='title-modal-news'>Suscripción con éxito</div>
                                </div>
                                <div className="success">
                                    <div>
                                        <p className="desc">Ahora recibirás nuestro newsletter al correo:</p>
                                    </div>
                                    <div>
                                        <p className="mail">{correo}</p>
                                    </div>
                                    <div className="close">
                                        <span onClick={()=>props.closeModal()}>Continuar</span>
                                    </div>
                                </div>
                            </div>
                        }


                    </div>
                </div>
        
        
    )
}
export default ModalSuscribe;